import { useEffect } from "react";

const ICON_LINKS: { rel: string; href: string; sizes?: string; type?: string }[] = [
  { rel: "icon", href: "/images/agents/favicon.ico", sizes: "any" },
  { rel: "icon", href: "/images/agents/favicon-32.png", sizes: "32x32", type: "image/png" },
  { rel: "icon", href: "/images/agents/icon-192.png", sizes: "192x192", type: "image/png" },
  { rel: "apple-touch-icon", href: "/images/agents/apple-touch-icon.png", sizes: "180x180" },
];

/** Override root favicon links while the Agents shell is mounted. */
export function AgentsDocumentIcons() {
  useEffect(() => {
    const created: HTMLLinkElement[] = [];
    for (const spec of ICON_LINKS) {
      const link = document.createElement("link");
      link.rel = spec.rel;
      link.href = spec.href;
      if (spec.sizes) link.sizes = spec.sizes;
      if (spec.type) link.type = spec.type;
      link.dataset.agentsIcon = "1";
      document.head.appendChild(link);
      created.push(link);
    }
    return () => {
      for (const link of created) link.remove();
    };
  }, []);

  return null;
}
